<div class="modal-header">
	<h4 class="modal-title synchpc-primary" id="modal-title">Add Application</h4>
	<i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey" style="padding: 17px;">
	<form name="addApplicationForm" [formGroup]="addApplicationForm" (ngSubmit)="onSubmit(addApplicationForm)" autocomplete="off" spellcheck="false" style="overflow:auto; padding:6px;" class="d-flex flex-wrap justify-content-between " >
		<mat-form-field appearance="fill">
			<mat-label>Deployment</mat-label>
			<mat-select formControlName="newAppDeployment">
				<mat-option selected value="{{depName}}" style="color: var(--s-text-color) !important">{{depName}}</mat-option>
			</mat-select>
			<mat-error *ngIf='addApplicationForm.get("newAppDeployment").touched && addApplicationForm.get("newAppDeployment").errors'>Required</mat-error>
		</mat-form-field>

		<mat-form-field appearance="fill">
			<mat-label>Select Application</mat-label>
			<mat-select formControlName="newApplication" (selectionChange)="checkApplicationName($event.value)">
				<mat-option *ngFor="let app of appNames" value="{{app}}">{{app}}</mat-option>
			</mat-select>
			<mat-error *ngIf='addApplicationForm.get("newApplication").touched && addApplicationForm.get("newApplication").errors'>Required</mat-error>
		</mat-form-field>

		<ng-container *ngIf="addApplicationForm.get('newApplication').value == 'Other'">
			<mat-form-field>
				<mat-label>Application Name</mat-label>
				<input matInput title="Enter Application Name." placeholder="Application Name" formControlName="customAppName" />
				<mat-error *ngIf='addApplicationForm.get("customAppName").touched && addApplicationForm.get("customAppName").errors?.required'>Required</mat-error>
				<mat-error *ngIf='addApplicationForm.get("customAppName").touched && addApplicationForm.get("customAppName").errors?.pattern'>Alphabets, Numbers, '_ - &#64;' allowed.</mat-error>
			</mat-form-field>
		</ng-container>

		<mat-form-field>
			<mat-label>Application Version</mat-label>
			<input matInput title="Enter application version." placeholder="Application Version" formControlName="newAppVersion" />
			<mat-error *ngIf='addApplicationForm.get("newAppVersion").touched && addApplicationForm.get("newAppVersion").errors?.required'>Required</mat-error>
			<mat-error *ngIf='addApplicationForm.get("newAppVersion").touched && addApplicationForm.get("newAppVersion").errors?.pattern'>Alphabets, Numbers, '_ - . &#64;' allowed.</mat-error>
		</mat-form-field>

		<mat-form-field appearance="fill">
			<mat-label>Applicable for</mat-label>
			<mat-select formControlName="applicationType">
				<mat-option *ngFor='let app of applicationTypes' value='{{app.value}}'>{{app.name}}</mat-option>
			</mat-select>
		</mat-form-field>

		<ng-container *ngIf="addApplicationForm.get('applicationType').value != 2">
			<mat-form-field appearance="fill">
				<mat-label>Add MPI</mat-label>
				<mat-select formControlName="newAppMpi">
					<mat-option *ngFor='let mpi of mpis' value='{{mpi.value}}'>{{mpi.name}}</mat-option>
				</mat-select>
				<mat-error *ngIf='addApplicationForm.get("newAppMpi").touched && addApplicationForm.get("newAppMpi").errors'>Required</mat-error>
			</mat-form-field>

			<mat-form-field appearance="fill">
				<mat-label>License Check</mat-label>
				<mat-select formControlName="newAppLicenseCheck">
					<mat-option value='true'>Enabled</mat-option>
					<mat-option value='false'>Disabled</mat-option>
				</mat-select>
				<mat-error *ngIf='addApplicationForm.get("newAppLicenseCheck").touched && addApplicationForm.get("newAppLicenseCheck").errors'>Required</mat-error>
			</mat-form-field>

			<mat-form-field appearance="fill">
				<mat-label>Add Fabric</mat-label>
				<mat-select formControlName="newAppFabric">
					<mat-option *ngFor='let fabric of fabrics' value='{{fabric.value}}'>{{fabric.name}}</mat-option>
				</mat-select>
				<mat-error *ngIf='addApplicationForm.get("newAppFabric").touched && addApplicationForm.get("newAppFabric").errors'>Required</mat-error>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Enter static cores.</mat-label>
				<input matInput title="Enter static cores." title="Add comma separated cores with which user will be able to submit job from available cores, if empty job can be submitted with any number of cores." placeholder="Static Cores" formControlName="staticCores" />
				<mat-error *ngIf='addApplicationForm.get("staticCores").touched && addApplicationForm.get("staticCores").errors?.pattern'>Only comma separated numbers allowed.</mat-error>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Enter queues specific for application.</mat-label>
				<input matInput title="Enter queues specific for application."
							title="Enter comma separated queues."
							placeholder="Queues"
							formControlName="applicationSpecificQueue"
							[matAutocomplete]="queue" />
				<mat-autocomplete #queue="matAutocomplete">
					<mat-option *ngFor="let queue of queuesFromDep" [value]="queue">
						{{ queue }}
					</mat-option>
				</mat-autocomplete>
				<mat-error *ngIf='addApplicationForm.get("applicationSpecificQueue").touched'>It is required.</mat-error>
			</mat-form-field>

			<mat-form-field matTooltip="Enter default memory space per CPU(in GB), e.g 1" matTooltipPosition="above">
				<mat-label>Enter default memory space per CPU(in GB), e.g 1</mat-label>
				<input matInput
							type="number"
							placeholder="Enter default memory space per CPU(in GB), e.g 1"
							formControlName="defaultMemorySpace" />
				<mat-error *ngIf="
						addApplicationForm.get('defaultMemorySpace').touched &&
						addApplicationForm.get('defaultMemorySpace').errors?.pattern
					">Please enter minimum scratch space (in GB), e.g 1. Enter only positive numbers.</mat-error>
			</mat-form-field>
		</ng-container>
		<br>

		<div class="modal-footer">
			<button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
			<button type="submit" class="btn btn-primary">
				Submit
			</button>
		</div>
	</form>
</div>

